import React, { useRef } from 'react'
import classNames from 'classnames'
import { post } from '~/utils/api'

export const stars = {
  1: 'star-orange',
  2: 'star-red',
  3: 'star-blue',
  4: 'star-violet',
  5: 'star-green',
}

type Props = {
  star: { color: string } | null
  id: number
  type: 'client' | 'ticket'
}

const Star: React.FC<Props> = ({ star, id, type }) => {
  const elSpanRef = useRef<HTMLDivElement>(null)
  const currentColorClass = star ? star.color : null
  let currentColor = star
  let sendStarTimeout: any = null

  const handleClick = e => {
    e.preventDefault()

    const nextColor =
      !sendStarTimeout && currentColor ? null : getNextStarColor(currentColor)

    setColor(nextColor)

    if (sendStarTimeout) {
      clearTimeout(sendStarTimeout)
    }

    sendStarColor(Date.now(), nextColor)
  }

  const setColor = color => {
    currentColor = color

    const span = elSpanRef.current

    if (span) {
      span.removeAttribute('class')
      span.classList.add('fa-star')

      if (color) {
        span.classList.add('fa')
        span.classList.add('ticket-list-item-' + color.color)
      } else {
        span.classList.add('far')
      }
    }
  }

  const sendStarColor = (date, color) => {
    sendStarTimeout = setTimeout(
      async (date, color) => {
        if (Date.now() - date > 1500) {
          var colorId = color ? color.id : 0
          console.log('id' + id + ' colorid' + colorId)
          await post('stars/' + type + '/' + id + '/' + colorId)

          sendStarTimeout = null
        } else {
          sendStarColor(date, color)
        }
      },
      800,
      date,
      color
    )
  }

  return (
    <>
      <span onClick={e => handleClick(e)} className={'ticket-list-item-star'}>
        <span
          className={classNames(
            'fa-star ticket-list-item-' + currentColorClass,
            {
              far: !star,
              fa: star,
            }
          )}
          ref={elSpanRef}
        ></span>
      </span>
    </>
  )
}

function getNextStarColor(color) {
  let colors = window.c.stars
  let currentK: number = 0

  if (color) {
    for (var k in colors) {
      if (colors[k].id == color.id) {
        currentK = Number(k)
        break
      }
    }
  }

  for (let k in colors) {
    if (Number(k) > currentK) {
      return colors[k]
    }
  }

  return null
}

export default Star
